module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/funds-885082022300a076ad3816a1fa17b2d8.svg";